<!-- *************************************************************************
TEMPLATE
************************************************************************* -->
<template>
  <div
    v-if="quizData.answerers.length"
    class="compos container"
  >
    <div class="box chart">
      <center>
        <h4 class="scoreboard_title">
          {{ $t('quiz.top') }}
        </h4>
        <div class="scoreboard_container">
          <table class="scoreboard">
            <tbody>
              <tr>
                <th id="name_page_name">
                  {{ $t('quiz.name') }}
                </th>
                <th
                  id="name_page_score"
                  style="width:30%;"
                >
                  {{ $t('quiz.score') }}
                </th>
              </tr>
              <template
                v-for="answerer in answerersSorted"
              >
                <tr
                  :key="answerer.id"
                  :class="'rank' + (answerer.score)"
                >
                  <td>{{ answerer.name }}</td>
                  <td>{{ answerer.score }}</td>
                </tr>
              </template>
            </tbody>
          </table>
          <span
            class="hidden_element note_text note_for_scoreboard"
            style="display: none;"
          >
            Note:
          </span>
        </div>
      </center>
    </div>
  </div>
</template>

<!-- *************************************************************************
SCRIPT
************************************************************************* -->

<script>
import orderBy from 'lodash/orderBy'

export default {
  name: 'ChartCompo',
  components: {
  },
  // eslint-disable-next-line
  props: [ 'quizData' ],
  data () {
    return {
    }
  },
  computed: {
    answerersSorted () {
      return orderBy(this.quizData.answerers, ['score', 'name'], ['desc', 'asc'])
    },
    hasAnswerers () {
      if (this.quizData.answerers === undefined || this.quizData.answerers.length === 0) {
        return false
      } else {
        return true
      }
    }
  },
  watch: {
  },
  methods: {
  }
}
</script>

<!-- *************************************************************************
STYLE
************************************************************************* -->

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
